import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { GetRotationPlanById } from '../../../../store/HR/Raqeeb/raqeebSlice';

const useInitialValues = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.Raqeeb.RotationPlanListById);
  const loading = useSelector((state) => state.Raqeeb.loading);
  const error = useSelector((state) => state.Raqeeb.error);
  
  useEffect(() => {
    dispatch(GetRotationPlanById(id));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const mapDayValues = (dayData = {}) => ({
    startIn: dayData?.startIn || '',
    endOut: dayData?.endOut || '',
    fingerprintTime1: dayData?.fingerprintTime1 || '00:00:00',
    fingerprintTime2: dayData?.fingerprintTime2 || '00:00:00',
    duration1: dayData?.duration1 || '',
    fingerprintTime3: dayData?.fingerprintTime3 || '00:00:00',
    fingerprintTime4: dayData?.fingerprintTime4 || '00:00:00',
    duration2: dayData?.duratioN2 || '',
    allowIn: dayData?.allowIn || '',
    allowOut: dayData?.allowOut || '',
    countFingerprint: String(dayData?.countFingerprint),
    isExtraDay: dayData?.isExtraDay || false,
    isFlexible: dayData?.isFlexible || false,
    startFlexible: dayData?.startFlexible || '00:00:00',
    endFlexible: dayData?.endFlexible || '00:00:00',

    startIn2: dayData?.startIn2 || '00:00:00',
    endOut2: dayData?.endOut2 || '00:00:00',
    // duratioN2: dayData?.duratioN2,
  });

  const initialValues = {
    raqRotationPlan: {
      name: data?.raqRotationPlansDto?.name || '',
      name2: data?.raqRotationPlansDto?.name2 || '',
      startDate: data?.raqRotationPlansDto?.startDate || '',
      endDate: data?.raqRotationPlansDto?.endDate || '',
      description: data?.raqRotationPlansDto?.description || '',
      allowIn: data?.raqRotationPlansDto?.allowIn || '',
      allowOut: data?.raqRotationPlansDto?.allowOut || '',
      count_Fingerprint: data?.raqRotationPlansDto?.count_Fingerprint || '',
    },
    sat: mapDayValues(data?.sat),
    sun: mapDayValues(data?.sun),
    mon: mapDayValues(data?.mon),
    tue: mapDayValues(data?.tue),
    wed: mapDayValues(data?.wed),
    thu: mapDayValues(data?.thu),
    fri: mapDayValues(data?.fri),
  };
  // console.log(data?.sat);

  return { data, loading, error, initialValues };
};

export default useInitialValues;
